import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { key: String, leadsUrl: String };
  static targets = ["text"];

  connect() {
    if (this._shouldSuppress()) return;
    const entry = this._readEntry();
    if (!entry) return;
    if (this.hasTextTarget) this.textTarget.textContent = "Restore filters from your last visit?";
    this.element.removeAttribute("hidden");
  }

  restore() {
    const entry = this._readEntry();
    if (!entry) return;
    const url = new URL(this.leadsUrlValue, window.location.origin);
    Array.from(url.searchParams.keys()).forEach((k) => url.searchParams.delete(k));
    Object.entries(entry.params || {}).forEach(([k, v]) => {
      if (Array.isArray(v)) {
        v.forEach((item) => url.searchParams.append(`${k}[]`, item));
      } else if (v != null && v !== "") {
        url.searchParams.set(k, v);
      }
    });
    window.location.href = url.toString();
  }

  dismiss() {
    sessionStorage.setItem(this._dismissKey(), "1");
    this.element.setAttribute("hidden", "");
  }

  _shouldSuppress() {
    if (sessionStorage.getItem(this._dismissKey())) return true;
    const sp = new URLSearchParams(window.location.search);
    // Drilldown origin OR cross-event target → suppress
    if (sp.has("segment_origin") || sp.has("segment_anchor") || sp.has("target_event_id")) return true;
    const filterKeys = [
      "date_preset", "from_date", "to_date", "scan_date_exact",
      "quality_band", "quality_min", "quality_max",
      "scanner_id", "activation_id", "scan_hour", "scan_dow",
      "state", "country", "city",
      "assigned_rep_id", "assigned_territory_id", "rep_id",
      "qualifier_id", "has_notes", "qualified",
      "business_type", "company_type", "position", "volume", "price_point",
      "is_returning_attendee", "company_name", "cfv",
      "q"
    ];
    // BUG #12: after the array-params migration, array filters appear in the
    // URL as key[] (?country[]=US). sp.has("country") misses those, so the
    // banner wrongly showed (and could clobber active filters on Restore).
    // Treat both the bare key and its []-suffixed form as present.
    if (filterKeys.some((k) => sp.has(k) || sp.has(`${k}[]`))) return true;
    // BUG #12 (LOW gap): demographic CFV filters reach the URL NESTED as
    // cfv[<id>][]=… — neither "cfv" nor "cfv[]" matches. Treat any key that
    // starts with "cfv[" as a CFV filter.
    for (const rawKey of sp.keys()) {
      if (rawKey.startsWith("cfv[")) return true;
    }
    return false;
  }

  _readEntry() {
    try {
      const raw = localStorage.getItem(this.keyValue);
      if (!raw) return null;
      const entry = JSON.parse(raw);
      const savedAt = Date.parse(entry.savedAt);
      if (!savedAt) return null;
      const ageDays = (Date.now() - savedAt) / 86400000;
      if (ageDays > 30) return null;
      return entry;
    } catch { return null; }
  }

  _dismissKey() { return `leads-filter-restore-dismissed:${this.keyValue}`; }
}
